import { trackProfileEvent } from './eSputnikAnalytics';

const trackProfile = (profile) => {
  return trackProfileEvent(profile).then(() => profile);
};

export { trackProfile };
